<template>
  <div class="side-matches">
    <scroller>
      <div
        class="side-matches-scroller"
        v-max-height="{
          el: ['.header-menu', '.footer'],
          offset: 25
      }">
        <div
          class="sport-wrapper"
          v-for="sport in sports"
          :key="sport.id"
          :class="['sport-' + sport.providerId]">
          <div
            class="sport-header"
            @click="toggleSport(sport)">
            <div class="sport-name">{{ sport.name }}</div>
            <div class="matches-count">({{ sport.numberOfMatches }})</div>
            <div class="icon-wrapper">
              <i
                class="n-i n-i-arrow-down-a"
                :class="{ 'n-i-arrow-up-a': sport.showTournaments }"/>
            </div>
          </div>
          <div
            class="tournaments-wrapper"
            v-for="tournament in sport.tournaments"
            :key="tournament.id"
            v-show="sport.showTournaments">
            <div
              class="tournament"
              @click="toggleTournament(tournament)">
              <div class="flag-wrapper">
                <div
                  class="flag"
                  :class="'flag-' + getCategoryIso(tournament.idCategory)" />
              </div>
              <div class="tournament-name">{{ tournament.name }}</div>
              <div class="icon-wrapper">
                <i
                  class="n-i n-i-arrow-down-a"
                  :class="{ 'n-i-arrow-up-a': tournament.showMatches }"/>
              </div>
            </div>
            <div
              class="matches"
              v-if="tournament.showMatches">
              <div
                class="match-wrapper"
                :class="{ active: activeMatch.id === match.id }"
                v-for="match in tournament.matches"
                :key="match.id">
                <router-link
                  :to="{ name: 'EventView', params: { id: match.id } }"
                  tag="div">
                  <div class="match-time">
                    {{ match.timestampUTC | time('dddd, HH:mm').toUpperCase() }}
                  </div>
                  <div
                    class="team"
                    v-for="team in match.teams"
                    :key="team.id">
                    {{ team.name }}
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </scroller>
  </div>
</template>

<script>
export default {
  computed: {
    sports() {
      return this.$store.getters.getSideViewMatches;
    },
    activeMatch() {
      return this.$store.getters.getActiveMatch;
    },
  },
  methods: {
    toggleSport(item) {
      const sport = item;
      sport.showTournaments = !sport.showTournaments;
    },
    toggleTournament(item) {
      const tournament = item;
      tournament.showMatches = !tournament.showMatches;
    },
    getCategoryIso(id) {
      const category = this.$store.getters.getCategoryById(id);
      return category ? _.toLower(category.isoName) || 'int' : 'int';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../scss/default/flags';
.side-matches-scroller {
  overflow: auto;
}

.flag-wrapper {
  position: absolute;
  transform: scale(0.75);
  top: 10px;
}
</style>
